import { render, staticRenderFns } from "./ShowAllOrders.vue?vue&type=template&id=63f8a80a&scoped=true"
import script from "./ShowAllOrders.vue?vue&type=script&lang=js"
export * from "./ShowAllOrders.vue?vue&type=script&lang=js"
import style0 from "./ShowAllOrders.vue?vue&type=style&index=0&id=63f8a80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8a80a",
  null
  
)

export default component.exports